import * as z from "zod";

export const publishAutomationGroup = {
  name: "publishAutomationGroup" as const,
  input: z.object({ ruleId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
